import { Breakpoint } from "@material-ui/core/styles/createBreakpoints"

export const showLogo: Breakpoint = "lg"
